<template>
  <div>
    <Head title="Create Airport" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item"><Link href="/settings/products">Products</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Create Product</li>
      </ol>
    </nav>
    <h1>Create Product</h1>

    <div class="content-box">
      <form @submit.prevent="store">
        <ProductForm :form="form" />

        <div class="actions-toolbar">
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Create Product</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ProductForm from './components/ProductForm'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    ProductForm,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        category: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/settings/products')
    },
  },
}
</script>
